import * as React from 'react';
import InputMask from 'react-input-mask';

import { AppFormField, AppFormFieldProps, AppFormFieldOwnProps } from './appFormField';

interface AppNumberFieldProps extends AppFormFieldOwnProps {
  integer?: boolean;
  positive?: boolean;
}

const defaultMask = {
  mask: '?999999999999',
  maskChar: '',
};

export class AppNumberField extends AppFormField<AppNumberFieldProps> {
  protected renderInput(field: AppFormFieldProps): JSX.Element {
    const { integer, positive } = this.props;
    const { input } = field;

    const inputMask = {
      ...defaultMask,
      formatChars: {
        '9': integer ? '[0-9]' : '[0-9,.]',
        '?': positive ? '[0-9]' : '[-0-9]',
      },
    };

    return (
      <InputMask
        {...inputMask}
        {...input}
        className={`${this.isFieldInvalid(field) ? 'invalid' : ''} text-input form-control`}
        placeholder={this.props.placeholder}
        disabled={this.props.disabled}
      />
    );
  }
}
